import React from "react";

import { Form } from "src/components";

export default props => <Form flexDirection="column" {...props} />;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js